// MemoLake デザイントークン（フロントエンド用）

export const T = {
  bg:         '#0a0b0e',
  bgRaised:   '#12141a',
  bgPanel:    '#181b22',
  bgHover:    '#1e222c',
  bgActive:   '#222738',
  border:     '#1f232e',
  borderHi:   '#2a2f3d',
  text:       '#e8eaf0',
  textDim:    '#8b92a5',
  textMute:   '#4a5068',
  accent:     'oklch(0.72 0.16 258)',
  accentSoft: 'oklch(0.72 0.16 258 / 0.12)',
  accentBorder:'oklch(0.72 0.16 258 / 0.28)',
  ok:         'oklch(0.74 0.14 152)',
  okSoft:     'oklch(0.74 0.14 152 / 0.12)',
  warn:       'oklch(0.78 0.15 68)',
  warnSoft:   'oklch(0.78 0.15 68 / 0.12)',
  font:       '"DM Sans", -apple-system, system-ui, sans-serif',
  fontMono:   '"JetBrains Mono", "Fira Code", ui-monospace, monospace',
} as const;

export const CAT_HUES: Record<string, number> = {
  tech: 210, genai: 270, paper: 240, news: 350,
  recipe: 30, eatery: 50, global: 180, social: 160,
  medical: 130, hobby: 320, memo: 0,
  finance: 120, life: 55, gadget: 200,
};

export const CAT_LABELS: Record<string, string> = {
  tech: '技術', genai: '生成AI', paper: '論文', news: 'ニュース',
  recipe: 'レシピ', eatery: '食事処', global: '海外記事', social: 'SNS',
  medical: '医療', hobby: '趣味', memo: 'メモ',
  finance: '金融', life: '生活', gadget: 'ガジェット',
};

export const MODE_LABELS: Record<string, string> = {
  raw: '保存のみ', save: '保存+要約', research: 'ウェブ検索', expand: '深掘り',
  rewrite: '書き直し', custom: 'カスタム',
};

export function catColor(catId: string | null): string {
  const hue = CAT_HUES[catId ?? 'memo'] ?? 260;
  return hue === 0 ? T.textDim : `oklch(0.72 0.14 ${hue})`;
}

export function catBg(catId: string | null): string {
  const hue = CAT_HUES[catId ?? 'memo'] ?? 260;
  return hue === 0 ? 'rgba(255,255,255,0.04)' : `oklch(0.72 0.14 ${hue} / 0.1)`;
}

export function confidenceColor(val: number | null): string {
  if (!val) return T.textMute;
  if (val >= 0.9) return T.ok;
  if (val >= 0.8) return T.textDim;
  return T.warn;
}

export interface Category {
  id: string;
  label: string;
  icon: string | null;
  hue: number;
  mono: boolean;
  sort_order: number;
}
